import { useState } from 'react';

import PropTypes from 'prop-types';

import Button from '@zenbusiness/zui/Button';

import CtaContainer from '#client/components/CtaContainer';
import { validateEnumValue } from '#client/utils/dataValidation/enumValidation';

import * as Styled from './SingleChoiceSelection.style';

const SingleChoiceSelection = ({
  defaultValue = '',
  options,
  primaryAction,
  secondaryAction,
  value
}) => {
  const [selectedValue, setSelectedValue] = useState(
    validateEnumValue(
      options.map((opt) => opt.value),
      value
    ) || defaultValue
  );

  const handleClick = (option) => {
    setSelectedValue(option.value);
  };

  return (
    <Styled.Container>
      {options.map((option) => (
        <Styled.OptionsButton
          key={option.value}
          clickstreamProps={{
            elementName: 'single_choice_option',
            elementValue: option.value
          }}
          data-selected={selectedValue === option.value}
          data-testid={`single-choice-option-${option.value}`}
          onClick={() => handleClick(option)}
        >
          {option.label}
        </Styled.OptionsButton>
      ))}
      <CtaContainer marginBlockStart={2}>
        <Button
          clickstreamProps={primaryAction.clickstreamProps}
          color="primary"
          data-testid={primaryAction['data-testid']}
          disabled={!selectedValue}
          fullWidth
          loading={primaryAction.loading}
          type="submit"
          variant="contained"
          onClick={() => primaryAction.onClick(selectedValue)}
        >
          {primaryAction.label}
        </Button>
        {secondaryAction && (
          <Button
            clickstreamProps={secondaryAction.clickstreamProps}
            data-testid={secondaryAction['data-testid']}
            fullWidth
            variant="outlined"
            onClick={() => secondaryAction.onClick()}
          >
            {secondaryAction.label}
          </Button>
        )}
      </CtaContainer>
    </Styled.Container>
  );
};

SingleChoiceSelection.propTypes = {
  defaultValue: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  ).isRequired,
  primaryAction: PropTypes.shape({
    'data-testid': PropTypes.string,
    clickstreamProps: PropTypes.object.isRequired,
    label: PropTypes.string.isRequired,
    loading: PropTypes.bool,
    onClick: PropTypes.func.isRequired
  }),
  secondaryAction: PropTypes.shape({
    'data-testid': PropTypes.string,
    clickstreamProps: PropTypes.object.isRequired,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired
  }),
  value: PropTypes.string
};

export default SingleChoiceSelection;
